import styled, { StyledProps } from 'styled-components'
import { IconCross } from '../../iconography/Icons/Icons'

export const ClearIcon = styled(IconCross)`
  width: 9.26px;
  height: 9.26px;
  position: absolute;
  top: 50%;
  right: 7px;
  transform: translateY(-50%);
  opacity: 1;
  transition: 0.3s opacity, 0.3s fill;
  cursor: pointer;

  &:hover {
    fill: ${({ theme }) => theme.color.primary600};
  }
`
export const CalendarContainer = styled.div`
  position: absolute;
  width: min-content;
  top: 40px;
`

export const Dash = styled.div`
  height: 1px;
  width: 10px;
  background-color: ${({ theme }) => theme.color.secondary200};
  margin-right: 6px;
  margin-left: 6px;
`

export const InputWrapper = styled.div<StyledProps<{ isFocused?: boolean; isValid?: boolean }>>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 32px;
  width: 210px;
  padding: 6px 15px;
  position: relative;
  background: ${({ theme }) => theme.color.onPrimaryLight};
  border: 1px solid;
  box-sizing: border-box;
  border-radius: 4px;
  transition: 0.3s border-color;

  ${({ theme, isFocused, isValid }) => ({
    borderColor: isValid
      ? isFocused
        ? theme.color.primary600
        : theme.color.onSurfaceLowEmphasys
      : theme.color.accentDestructive,
  })}

  &:hover {
    border-color: ${({ theme, isValid }) => (isValid ? theme.color.onPrimaryMid : theme.color.accentDestructive)};
  }
`

export const Input = styled.input`
  text-align: center;
  width: 80px;
  padding: 0;
  flex-grow: 1;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  font-family: Montserrat;
  font-style: normal;

  color: ${({ theme }) => theme.color.onPrimaryDark};
  outline: none;
  border: none;
  &::placeholder {
    opacity: 0.48;
  }

  ${props => props.theme.media.mobile`
    font-size: 16px;
  `}
`

export const Wrapper = styled.div`
  position: relative;
  outline: none;
`

export const Optional = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.color.accentNotify};
  margin-left: auto;
  text-transform: none;
  position: absolute;
  bottom: calc(100% + 8px);
  right: 0;
`

export const ErrorText = styled.div`
  color: ${({ theme }) => theme.color.accentDestructive};
  margin-top: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  position: absolute;
  top: 100%;
`
